import { createAction, props } from '@ngrx/store';

export const LinksCta = createAction(
  '[GA Product tips] CTA clicked',
  props<{ label: string; eventAction: string; includeMetaData?: boolean }>()
);

export const PolicyPageLoaded = createAction('[GA Product Upsell] Page Loaded');

export type ProductUpsellActions = typeof LinksCta | typeof PolicyPageLoaded;
